export default {
  'base.captcha.clickToVerify': 'Click to verify',
  'base.captcha.verified': 'Verified',
  'base.captcha.title': 'Security Verification',
  'base.captcha.loading': 'Loading...',
  'base.captcha.dragHint': 'Drag the slider to complete verification',
  'base.captcha.failCountdown': 'Verification failed, auto-refresh in {countdown}s',
  'base.captcha.refreshing': 'Refreshing...',
  'base.captcha.refreshNow': 'Refresh now',
  'base.avatarCrop.title': 'Crop Avatar',
  'base.avatarCrop.hint': 'Drag to reposition, scroll or slide to zoom',
  'base.avatarCrop.invalidImage': 'Please select an image file',
  'base.avatarCrop.tooLarge': 'Image too large, please choose a file up to 5MB',
  'base.avatarCrop.processFailed': 'Failed to process image',
  'base.markdownEditor.uploadFailed': 'Failed to upload image',
}
